import { DeliveredStatus } from '@amzn/aet-coachingform-kit/lib/types';

import { EmptyExtendedUser, ExtendedUser } from './ExtendedUser';
import { EmptyMetric, Metric } from './Metric';
import { EmptySummaryMetric, SummaryMetric } from './SummaryMetric';
import { Goal } from '@amzn/aet-galactus-kit';
import { ContactReviewStatusOptions } from '../api/Outlier/schema';

export class Team {
  keys: string[];

  summaryMetrics: SummaryMetric;

  metrics: [
    {
      user: ExtendedUser;
      metrics: Metric;
      tm: boolean;
    },
  ];

  constructor({ keys, metrics, summaryMetrics }: Record<string, any>) {
    this.keys = keys;
    this.summaryMetrics = summaryMetrics;
    this.metrics = metrics;
  }
}

export const EmptyTeam: Team = {
  keys: [],
  metrics: [
    {
      user: EmptyExtendedUser,
      metrics: EmptyMetric,
      tm: false,
    },
  ],
  summaryMetrics: EmptySummaryMetric,
};

export type WeeklySummaryCoachingStatus = {
  userID: string;
  lastCoachedDate: string;
  lastCoachingStatus: DeliveredStatus;
};

export type AssociateInsight = {
  associate: string;
  opportunities: {
    category: string;
    contacts: { contact: string; contactStatus: ContactReviewStatusOptions }[];
  }[];
  kudos: {
    category: string;
    contacts: { contact: string; contactStatus: ContactReviewStatusOptions }[];
  }[];
  bottomQuartileMetrics: BottomQuartileMetric[];
};

export type BottomQuartileMetric = {
  label: string;
  metricName: string;
};

export type AssociateCardSummary = {
  isManager: boolean;
  userID?: string;
  userAlias?: string;
  relationToUser?: string;
  performance?: {
    trendSummary: (
      | {
          metric: string;
          delta: string | null;
          trendIndicator: string;
          endValue: string;
        }
      | undefined
    )[];
    metricTimestamp?: string;
  };
  coachings?: {
    lastCoachedDate: string;
    lastCoachingStatus: DeliveredStatus;
  };
  goals?: Goal[];
  opportunities?: {
    labelAndCount: {
      category: string;
      count: number;
      contacts: {
        contact: string;
        contactStatus: ContactReviewStatusOptions;
      }[];
    }[];
  };
  kudos?: {
    labelAndCount: {
      category: string;
      count: number;
      contacts: {
        contact: string;
        contactStatus: ContactReviewStatusOptions;
      }[];
    }[];
  };
  bottomQuartileMetrics?: {
    metricSummary: (
      | {
          metric: string;
          label: string;
        }
      | undefined
    )[];
  };
  metricsFromPreviousMonth?: {
    metric: string;
    value: string;
    netAvg: string;
  }[];
};
